module.exports = __webpack_public_path__ + "img/travel_thumbnail-400x300.e560f673.jpg";